import fetch from "auth/FetchInterceptor";

export const OtherService = {};

OtherService.getLoyalty = async () => {
  let apiUrl = "/v1/setting/other/loyalty-point-in-idr";
  return fetch({
    url: apiUrl,
    method: "get",
  });
};

OtherService.updateLoyalty = async (data) => {
  let apiUrl = "/v1/setting/other/loyalty-point-in-idr";
  return fetch({
    url: apiUrl,
    method: "put",
    data: data,
  });
};

export default OtherService;
